/* tslint:disable */
/* eslint-disable */
/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime';
import { MembershipLinkRequestToJSON, UnlinkedMembershipFromJSON, } from '../models/index';
/**
 *
 */
export class HelloAssoApi extends runtime.BaseAPI {
    /**
     * Receive a Cercle Montfortais relayed notification and persist adhesions.  Coexists with the HelloAsso webhook: the Cercle relays adhesions it collects on its own app in a flat French-keyed shape. Authenticated by an HMAC-SHA256 signature over ``timestamp + \".\" + raw_body`` carried in the ``X-Cercle-Timestamp`` / ``X-Cercle-Signature`` headers, keyed on ``cercle_webhook_secret``, with a 5-minute anti-replay window. Acknowledges authentic, well-formed but unrecognized notifications with 200 so the Cercle stops retrying.
     * Cercle Webhook
     */
    cercleWebhookApiV1HelloassoCercleWebhookPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (requestParameters['xCercleTimestamp'] != null) {
                headerParameters['x-cercle-timestamp'] = String(requestParameters['xCercleTimestamp']);
            }
            if (requestParameters['xCercleSignature'] != null) {
                headerParameters['x-cercle-signature'] = String(requestParameters['xCercleSignature']);
            }
            const response = yield this.request({
                path: `/api/v1/helloasso/cercle/webhook`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Receive a Cercle Montfortais relayed notification and persist adhesions.  Coexists with the HelloAsso webhook: the Cercle relays adhesions it collects on its own app in a flat French-keyed shape. Authenticated by an HMAC-SHA256 signature over ``timestamp + \".\" + raw_body`` carried in the ``X-Cercle-Timestamp`` / ``X-Cercle-Signature`` headers, keyed on ``cercle_webhook_secret``, with a 5-minute anti-replay window. Acknowledges authentic, well-formed but unrecognized notifications with 200 so the Cercle stops retrying.
     * Cercle Webhook
     */
    cercleWebhookApiV1HelloassoCercleWebhookPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.cercleWebhookApiV1HelloassoCercleWebhookPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Delete a membership record (e.g. a duplicate or erroneous order).
     * Delete Membership
     */
    deleteMembershipApiV1HelloassoOrdersMembershipIdDeleteRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['membershipId'] == null) {
                throw new runtime.RequiredError('membershipId', 'Required parameter "membershipId" was null or undefined when calling deleteMembershipApiV1HelloassoOrdersMembershipIdDelete().');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/helloasso/orders/{membership_id}`.replace(`{${"membership_id"}}`, encodeURIComponent(String(requestParameters['membershipId']))),
                method: 'DELETE',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Delete a membership record (e.g. a duplicate or erroneous order).
     * Delete Membership
     */
    deleteMembershipApiV1HelloassoOrdersMembershipIdDelete(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.deleteMembershipApiV1HelloassoOrdersMembershipIdDeleteRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Receive a HelloAsso notification and persist membership items.  Always returns 200 for authentic, well-formed notifications (even when there is nothing to store), because any non-200 makes HelloAsso retry the delivery for up to 27 hours.
     * Helloasso Webhook
     */
    helloassoWebhookApiV1HelloassoWebhookPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            if (requestParameters['token'] != null) {
                queryParameters['token'] = requestParameters['token'];
            }
            const headerParameters = {};
            if (requestParameters['xHaSignature'] != null) {
                headerParameters['x-ha-signature'] = String(requestParameters['xHaSignature']);
            }
            const response = yield this.request({
                path: `/api/v1/helloasso/webhook`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            if (this.isJsonMime(response.headers.get('content-type'))) {
                return new runtime.JSONApiResponse(response);
            }
            else {
                return new runtime.TextApiResponse(response);
            }
        });
    }
    /**
     * Receive a HelloAsso notification and persist membership items.  Always returns 200 for authentic, well-formed notifications (even when there is nothing to store), because any non-200 makes HelloAsso retry the delivery for up to 27 hours.
     * Helloasso Webhook
     */
    helloassoWebhookApiV1HelloassoWebhookPost() {
        return __awaiter(this, arguments, void 0, function* (requestParameters = {}, initOverrides) {
            const response = yield this.helloassoWebhookApiV1HelloassoWebhookPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Attach an unlinked membership row to a member.
     * Link Membership
     */
    linkMembershipApiV1HelloassoOrdersMembershipIdLinkPostRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters['membershipId'] == null) {
                throw new runtime.RequiredError('membershipId', 'Required parameter "membershipId" was null or undefined when calling linkMembershipApiV1HelloassoOrdersMembershipIdLinkPost().');
            }
            if (requestParameters['membershipLinkRequest'] == null) {
                throw new runtime.RequiredError('membershipLinkRequest', 'Required parameter "membershipLinkRequest" was null or undefined when calling linkMembershipApiV1HelloassoOrdersMembershipIdLinkPost().');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/helloasso/orders/{membership_id}/link`.replace(`{${"membership_id"}}`, encodeURIComponent(String(requestParameters['membershipId']))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: MembershipLinkRequestToJSON(requestParameters['membershipLinkRequest']),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => UnlinkedMembershipFromJSON(jsonValue));
        });
    }
    /**
     * Attach an unlinked membership row to a member.
     * Link Membership
     */
    linkMembershipApiV1HelloassoOrdersMembershipIdLinkPost(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.linkMembershipApiV1HelloassoOrdersMembershipIdLinkPostRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * List membership rows not yet attached to a member (admin reconciliation).
     * List Unlinked Memberships
     */
    listUnlinkedMembershipsApiV1HelloassoOrdersUnlinkedGetRaw(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.accessToken) {
                const token = this.configuration.accessToken;
                const tokenString = yield token("HTTPBearer", []);
                if (tokenString) {
                    headerParameters["Authorization"] = `Bearer ${tokenString}`;
                }
            }
            const response = yield this.request({
                path: `/api/v1/helloasso/orders/unlinked`,
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UnlinkedMembershipFromJSON));
        });
    }
    /**
     * List membership rows not yet attached to a member (admin reconciliation).
     * List Unlinked Memberships
     */
    listUnlinkedMembershipsApiV1HelloassoOrdersUnlinkedGet(initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.listUnlinkedMembershipsApiV1HelloassoOrdersUnlinkedGetRaw(initOverrides);
            return yield response.value();
        });
    }
}
